// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");

function empty(param) {
  return {
          id: undefined,
          message: "",
          apiConfigurationId: undefined
        };
}

function setApiConfigurationId(apiConfigurationId, t) {
  return {
          id: t.id,
          message: t.message,
          apiConfigurationId: apiConfigurationId
        };
}

function apiConfigurationId(t) {
  return t.apiConfigurationId;
}

function validApiConfigurationId(x) {
  return x !== undefined;
}

function toForm(t) {
  return {
          id: {
            TAG: "Valid",
            _0: t.id
          },
          message: {
            TAG: "Valid",
            _0: t.message
          },
          apiConfigurationId: validApiConfigurationId(t.apiConfigurationId) ? ({
                TAG: "Valid",
                _0: t.apiConfigurationId
              }) : ({
                TAG: "Invalid",
                _0: t.apiConfigurationId,
                _1: {
                  hd: "can't be empty",
                  tl: /* [] */0
                }
              })
        };
}

function fromForm(form) {
  return {
          id: FormField$ReactHooksTemplate.getInputValue(form.id),
          message: FormField$ReactHooksTemplate.getInputValue(form.message),
          apiConfigurationId: FormField$ReactHooksTemplate.getInputValue(form.apiConfigurationId)
        };
}

function encoder(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "message",
                  t.message
                ],
                tl: {
                  hd: [
                    "api_configuration_id",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), t.apiConfigurationId)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function decoder(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          message: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("message", Json_decode.string, param);
                }), json),
          apiConfigurationId: Json_decode.optional((function (param) {
                  return Json_decode.field("api_configuration_id", Json_decode.$$int, param);
                }), json)
        };
}

var modeType = "WhatsappLink";

exports.modeType = modeType;
exports.empty = empty;
exports.setApiConfigurationId = setApiConfigurationId;
exports.apiConfigurationId = apiConfigurationId;
exports.validApiConfigurationId = validApiConfigurationId;
exports.toForm = toForm;
exports.fromForm = fromForm;
exports.encoder = encoder;
exports.decoder = decoder;
/* No side effect */
